import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { INSTRUCTOR_IMAGE } from "../../data/media";

const STATS = [
  { k: "12+", v: "Years instructing" },
  { k: "1,400+", v: "Students trained" },
  { k: "100%", v: "Safety-first" },
];

const TEAM = [
  { handle: "campierre_", role: "Founder & Instructor", url: "https://www.instagram.com/campierre_" },
  { handle: "iamjgolley", role: "Founder & Instructor", url: "https://www.instagram.com/iamjgolley" },
  { handle: "matchgrademediastl", role: "Founder & Instructor", url: "https://www.instagram.com/matchgrademediastl" },
];

export default function Instructor() {
  return (
    <section id="instructor" className="relative py-24 md:py-36 max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-5 group relative"
        >
          <div className="relative overflow-hidden border border-white/10 aspect-[4/3]">
            <img src={INSTRUCTOR_IMAGE} alt="The Midwest Made team" className="w-full h-full object-cover object-top img-treat" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/50 to-transparent" />
          </div>
          <span className="absolute -bottom-4 -right-4 md:-right-6 bg-brand-orange text-brand-bg font-mono text-[10px] uppercase tracking-[0.2em] px-4 py-3">
            NRA · USCCA Certified
          </span>
        </motion.div>

        <div className="md:col-span-7">
          <div className="flex items-center gap-4 mb-6">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange">03 / The Team</span>
          </div>
          <h2 className="font-heading font-bold uppercase text-4xl md:text-6xl tracking-tighter text-brand-ink leading-[0.9]">
            Coached by people<br /><span className="text-brand-brass">who live it.</span>
          </h2>
          <p className="mt-8 max-w-xl text-brand-muted text-base leading-relaxed">
            We're a Midwest crew that trains together and holds each other to a higher standard.
            No ego, no theatrics — just patient, methodical coaching that meets you exactly where
            you are and takes you further than you thought you'd get.
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-white/10 pt-10">
            {STATS.map((s) => (
              <div key={s.v} data-testid={`stat-${s.k}`}>
                <div className="font-heading font-black text-3xl md:text-5xl text-brand-ink">{s.k}</div>
                <div className="mt-2 font-mono text-[10px] md:text-xs uppercase tracking-[0.15em] text-brand-muted">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 border-t border-white/10 pt-8">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-brass">Meet the crew · St. Louis, MO</span>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {TEAM.map((m) => (
                <a
                  key={m.handle}
                  href={m.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`team-${m.handle}`}
                  className="group flex items-center justify-between border border-white/10 rounded-sm px-4 py-3 hover:border-brand-orange transition-colors"
                >
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 text-brand-ink">
                      <Instagram size={14} className="text-brand-orange shrink-0" />
                      <span className="font-mono text-xs truncate">@{m.handle}</span>
                    </div>
                    <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.12em] text-brand-muted truncate">{m.role}</div>
                  </div>
                  <ArrowUpRight size={14} className="text-brand-muted group-hover:text-brand-orange group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
